document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".wp-block-brblocks-tabs").forEach((tabBlock) => {
    const buttonsContainer = tabBlock.querySelector("[data-tabs='buttons']");
    const titles = tabBlock.querySelectorAll(".tab-title");
    const contents = tabBlock.querySelectorAll(".tab-content");

    if (titles.length !== contents.length) return;

    // Créer les boutons
    titles.forEach((titleEl, index) => {
      const button = document.createElement("button");
      button.className = "tab-button";
      button.textContent = titleEl.textContent;

      button.addEventListener("click", () => {
        contents.forEach((c, i) => {
          c.style.display = i === index ? "block" : "none";
        });

        tabBlock.querySelectorAll(".tab-button").forEach(btn =>
          btn.classList.remove("active")
        );
        button.classList.add("active");
      });

      buttonsContainer.appendChild(button);
    });

    // Afficher le premier onglet
    contents.forEach((c, i) => {
      c.style.display = i === 0 ? "block" : "none";
    });
    const firstButton = buttonsContainer.querySelector(".tab-button");
    if (firstButton) firstButton.classList.add("active");
  });
});
